export default __webpack_public_path__ + "static/media/Finished_IMG4994.9b0c6754.jpg";